import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

// Starts a classification and polls the job until it resolves.
export const runClassifyJob = async ({ url, description, answers, refresh }, { signal } = {}) => {
  const { data } = await api.post("/public/classify", { url, description, answers, refresh });
  if (data.status === "done") return data.result;
  const jobId = data.job_id;
  for (let i = 0; i < 100; i++) {
    if (signal?.aborted) throw new Error("aborted");
    await sleep(1800);
    const { data: job } = await api.get(`/job/${jobId}`);
    if (job.status === "done") return job.result;
    if (job.status === "error") throw new Error(job.error || "Classification failed.");
  }
  throw new Error("Classification timed out. Please try again.");
};

export const TIER = {
  prohibited: { label: "Prohibited", color: "#D64545", bg: "rgba(214,69,69,0.06)", chip: "rgba(214,69,69,0.14)" },
  high: { label: "High-risk", color: "#E0A100", bg: "rgba(224,161,0,0.07)", chip: "rgba(224,161,0,0.16)" },
  limited: { label: "Limited-risk", color: "#364F6B", bg: "rgba(54,79,107,0.05)", chip: "rgba(54,79,107,0.10)" },
  minimal: { label: "Minimal-risk", color: "#5FBFD6", bg: "rgba(95,191,214,0.10)", chip: "rgba(95,191,214,0.20)" },
};

export const tierMeta = (t) => TIER[t] || TIER.minimal;

// Confidence value helper (unwrap { value, confidence, rationale } shapes safely)
export const val = (node, fallback = "") => {
  if (node === null || node === undefined) return fallback;
  if (typeof node === "object" && "value" in node) return node.value;
  return node;
};

export const conf = (node, fallback = "unknown") => {
  if (node && typeof node === "object" && node.confidence) return node.confidence;
  return fallback;
};
